import { Storybook } from "@tento-ui/ui/storybook";
import { ChatComposer } from "./chat-composer";

export class ChatComposerStoryBook extends Storybook.Default {
  title(): string {
    return "Chat Composer";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Default",
        render: () => {
          const $c = ChatComposer.make();
          $c.bind({
            onSend: (text) => {
              console.log("Sent:", text);
            },
          });
          return $c.assignStyles({
            width: "100%",
            maxWidth: "600px",
          });
        },
      },
      {
        title: "Custom Placeholder",
        render: () => {
          const $c = ChatComposer.make();
          $c.bind({
            placeholder: "Ask anything...",
            onSend: (text) => {
              console.log("Sent:", text);
            },
          });
          return $c.assignStyles({
            width: "100%",
            maxWidth: "600px",
          });
        },
      },
    ];
  }
}
